const LOG_OUT = 'account/log_out';
const LOGGED_OUT = 'account/logged_out';
const logOut = ()=>({
        type: LOG_OUT
    })
;
const loggedOut = ()=>({
        type: LOGGED_OUT
    })
;

export { LOGGED_OUT, LOG_OUT, logOut, loggedOut };
//# sourceMappingURL=actions.js.map
